import { OptionsType } from '@openx/types/options.ts';
import { useOptionsFetch } from '@openx/utils/apiHooks/generics/useOptionsFetch.tsx';
import { useTranslation } from 'react-i18next';

export function usePmpSizesFetch() {
  const { t } = useTranslation();
  const { isLoading: isSizesLoading, data: sizes } = useOptionsFetch({
    errorMessage: t('Failed to fetch ad unit sizes'),
    optionType: OptionsType.PMP_SIZE,
  });

  return {
    isSizesLoading,
    sizes,
  };
}
